import { render, staticRenderFns } from "./Complaint.vue?vue&type=template&id=b2ea10f6&scoped=true"
import script from "./Complaint.vue?vue&type=script&lang=js"
export * from "./Complaint.vue?vue&type=script&lang=js"
import style0 from "./Complaint.vue?vue&type=style&index=0&id=b2ea10f6&prod&lang=css"
import style1 from "./Complaint.vue?vue&type=style&index=1&id=b2ea10f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ea10f6",
  null
  
)

export default component.exports